'use client'

import { Box } from '@mui/material'

// Types
import type { GlowProps } from '@/types/components/atoms/animation'

// Soft color blob that slowly drifts behind content; CSS keyframes keep it on the compositor
const GlowAtom = (props: GlowProps) => {
	// Props
	const { top, start, size, color = 'primary', delay = 0 } = props

	return (
		<Box sx={{ position: 'absolute', top, insetInlineStart: start, width: size, height: size, pointerEvents: 'none', zIndex: 0 }}>
			<Box
				sx={{
					width: 1,
					height: 1,
					borderRadius: '50%',
					opacity: 0.7,
					background: t => `radial-gradient(circle closest-side, ${t.palette[color].light} 0%, transparent 100%)`,
					'@keyframes glowDrift': {
						'0%, 100%': { transform: 'translate(0, 0) scale(1)' },
						'50%': { transform: 'translate(30px, 20px) scale(1.08)' }
					},
					'@media (prefers-reduced-motion: no-preference)': { animation: `glowDrift 14s ease-in-out ${delay}s infinite`, willChange: 'transform' }
				}}
			/>
		</Box>
	)
}

export default GlowAtom
